import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError, Subject } from 'rxjs';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Schedule } from 'src/app/shared/models/schedule.model';

export class ReservationData {
  public enableReservation: boolean;
  public enableSlotReservation: boolean;
  public enablePaymentReservation: boolean;
  public normalReservation: NormalReservation;
  public slotReservation: SlotReservationSettings;
}

export class Reservation {
  public id: number;
  public firstName: string;
  public lastName: string;
  public email: string;
  public reservedPersons: number;
  public reservationCode: string;
  public createdAt: string;
  public expiredAt: string;
  public expiredTimeAt: string;
  public comment: string;
  public language: string;
  public status: number;
}

export class NormalReservation {
  public blockReservationAt: number;
  public expireReservationAt: number;
}

export class SlotReservationSettings {
  public id: number;
  public startHour: string;
  public endHour: string;
  public breakStartHour: string;
  public breakEndHour: string;
  public mondaySlot: number;
  public tuesdaySlot: number;
  public wednesdaySlot: number;
  public thursdaySlot: number;
  public fridaySlot: number;
  public saturdaySlot: number;
  public sundaySlot: number;
  public mondayAllowedPerson: number;
  public tuesdayAllowedPerson: number;
  public wednesdayAllowedPerson: number;
  public thursdayAllowedPerson: number;
  public fridayAllowedPerson: number;
  public saturdayAllowedPerson: number;
  public sundayAllowedPerson: number;
  public expireAfter: number;
  public startPeriod: any;
  public endPeriod: any;
  public organizationId: string;

}
export class SlotReservation {
  public id: number;
  public name: string;
  public email: string;
  public phone: string;
  public idNumber: string;
  public reservedPersons: number;
  public reservationCode: string;
  public reservationDate: string;
  public timeSlot: string;
  public expiredAt: string;
  public comment: string;
  public language: string;
  public status: number;
}

@Injectable({
  providedIn: 'root'
})
export class ReservationsService {

  public reservationSubject: Subject<ReservationData> = new Subject();
  public approveReservationSubject: Subject<number> = new Subject();
  public approveSlotReservationSubject: Subject<number> = new Subject();

  private _reservationData: ReservationData;

  constructor(private _http: HttpClient) { }



  public getReservationSettings(organizationId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('organizationId', organizationId);
    return this._http.get<ReservationData>(environment.serverUrl + 'reservation/getReservationSettings', {
      params: paramas,
    }).pipe(
      map(responseData => {
        this._reservationData = responseData;
        this.reservationSubject.next(responseData);
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * updateReservationValue
   */
  public updateReservationValue(orgId: string, type: number, number?: number, enabled?: boolean) {
    this._http
      .post<void>(
        environment.serverUrl + 'reservation/update',
        {
          'id': orgId,
          'type': type.toString(),
          'number': number,
          'enabled': enabled
        }
      ).subscribe(() => {
        switch (type) {
          case 1:
            this._reservationData.normalReservation.blockReservationAt = number;
            break;
          case 2:
            this._reservationData.normalReservation.expireReservationAt = number;
            break;
          case 3:
            this._reservationData.enableSlotReservation = enabled;
            break;
          default:
            this._reservationData.enableReservation = enabled;
            break;
        }
        this.reservationSubject.next(this._reservationData);
      });
  }

  /**
  * getReservations
  */
  public getReservations(organizationId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', organizationId);
    return this._http.get<Reservation[]>(environment.serverUrl + 'reservations/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * updateReservationValue
   */
  public approveReservation(code: string) {
    return this._http
      .post<Reservation>(environment.serverUrl + 'reservation/approve', { code }).pipe(
        map(responseData => {
          return responseData;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }

  public updateSlotReservationSettings(settings: SlotReservationSettings) {
    // settings.startPeriod = SlotReservationSettings.convertNgbDataStructureToDateString(settings.startPeriod);
    // settings.endPeriod = SlotReservationSettings.convertNgbDataStructureToDateString(settings.endPeriod);
    return this._http
      .post<void>(
        environment.serverUrl + 'slotReservation/saveSlotSettings',
        settings
      );
  }



  /**
  * getSlotReservations
  */
  public getSlotReservations(organizationId: string, date?: string, time?: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('organizationId', organizationId);
    if (date) {
      paramas = paramas.append('date', date);
    }
    if (time) {
      paramas = paramas.append('time', time);
    }
    return this._http.get<SlotReservation[]>(environment.serverUrl + 'slotReservation/getSlotReservations', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  /**
   * approveSlotReservation
   */
  public approveSlotReservation(code: string) {
    return this._http
      .post<Reservation>(environment.serverUrl + 'slotReservation/approveSlotReservation', { code }).pipe(
        map(responseData => {
          return responseData;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }
}
